<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 保/批单号 -->
            <el-table-column align="left" label="保/批单号" width="200px">
            <template slot-scope="scope">
                <span  class="text-link">{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 费用类型 -->
            <el-table-column align="left" label="费用类型">
            <template slot-scope="scope">
                <span >{{ scope.row.types_of_fee }}</span>
            </template>
            </el-table-column> 

            <!-- 投保人 -->
            <el-table-column align="left" label="投保人">
            <template slot-scope="scope">
                <span >{{ scope.row.insured }}</span>
            </template>
            </el-table-column>  

            <!-- 被保险人 -->
            <el-table-column align="left" label="被保险人">
            <template slot-scope="scope">
                <span >{{ scope.row.insured }}</span>
            </template>
            </el-table-column>                          

            <!-- 起保/生效日期 -->
            <el-table-column align="left" label="起保/生效日期" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.effective_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 签单日期 -->
            <el-table-column align="left" label="签单日期" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.issue_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种">
            <template slot-scope="scope">
                <span >{{ scope.row.insurance_type }}</span>
            </template>
            </el-table-column>

            <!-- 实收保费（不含税） -->
            <el-table-column align="left" label="实收保费（不含税）" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency}}</span>
            </template>
            </el-table-column>

            <!-- 手续费率(%) -->
            <el-table-column align="left" label="手续费率(%)" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate }}%</span>
            </template>
            </el-table-column>

            <!-- 手续费金额 -->
            <el-table-column align="left" label="手续费金额" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency}}</span>
            </template>
            </el-table-column>            

            <!-- 出单员 -->
            <el-table-column align="left" label="出单员" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.biller }}</span>
            </template>
            </el-table-column>

            <!-- 业务员 -->
            <el-table-column align="left" label="业务员" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.salesman }}</span>
            </template>
            </el-table-column>  
        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-guo-ren',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },        
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>